import { render, staticRenderFns } from "./RankingTable.vue?vue&type=template&id=6bd32fa9"
import script from "./RankingTable.vue?vue&type=script&lang=js"
export * from "./RankingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports